import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IDevelopmentProject } from "../interfaces/development-project.interface";
import { MKT_PROJECTS } from "../data/marketing-info";
import { IMarketingProject } from "../interfaces/marketing-project.interface";

@Injectable({
    providedIn: 'root',
})
export class MarketingProjectsService {

    private projects = MKT_PROJECTS;

    constructor(private http: HttpClient) { }

    getProjects(): Observable<IMarketingProject[]> {
        return of(this.projects);
    }

    getProjectIds(): string[] {
        return this.projects.map((p) => p.redirectUrl);
    }

    getProjectByName(name: string): Observable<IMarketingProject | undefined> {
        return of(this.projects.find(
            project => project.name.toLowerCase() === name.toLowerCase()
        ));
    }

    getProjectByUri(uri: string): Observable<IMarketingProject | undefined> {
        return of(this.projects.find(
            project => project.redirectUrl.toLowerCase() === uri.toLowerCase()
        ));
    }

}
